module.exports = () ->
  return {

    restrict: 'A'

    link: ( scope, element, attrs ) ->
      element.on 'click', (event) ->
        if scope.$eval(attrs.preventDefaultOnClickIf)
          event.preventDefault()
  }
